import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaChevronDown, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaBars, FaTimes } from 'react-icons/fa'; // Added FaBars, FaTimes
import api from '../../api/api'; // Import the API instance

import styles from '../Landing/LandingPage.module.css'; // Reusing general landing page styles
import supportStyles from './ContactSupportPage.module.css'; // New dedicated styles
import imageLogo from "../../assets/images/BSPLogoTranSmall.png";
import Header from "../Landing/components/Header";

/*
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src={imageLogo}
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}
          />
          BUILD START</div>
        <nav className={`${styles.nav} ${isMenuOpen ? styles.navMobile : ''}`}>
          <ul className={styles.navLinks}>
            <li className={styles.closeIcon} onClick={toggleMenu}><FaTimes /></li>
            <li><Link to="/">Home Owner</Link></li>
            <li><Link to="/business-landing">For Building Professionals</Link></li>
            <li><a href="/for-developers">For Renovators / Developers</a></li>
            <li><Link to="/resources-hub">Resource Hub</Link></li>
            <li className={styles.activeLink} ><a href="/contact-support">Support</a></li>
            <li className={styles.mobileAuth}>
              <Link to="/login" className={styles.btnLogin}>Login</Link>
            </li>
            <li className={styles.mobileAuth}>
              <Link to="/select-role" className={styles.btnRegister}>Register</Link>
            </li>
          </ul>
        </nav>
        <div className={styles.headerRight}>
          <Link to="/login" className={styles.btnLogin}>Login</Link>
          <Link to="/select-role" className={styles.btnRegister}>Register</Link>
        </div>
        <div className={styles.menuIcon} onClick={toggleMenu}>
          <FaBars />
        </div>
      </div>
    </header>
  );
};

*/

// Reusable Footer Component (from LandingPage.module.css)
const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerMain}>
          <div className={styles.footerAbout}>
            <div className={styles.logo}>Build Start</div>
            <p>Build Start is an invitation-only directory of the most trusted, vetted professionals in your area. Time to start building with confidence.</p>
            <div className={styles.socialIcons}>
              <a href="#facebook">f</a>
              <a href="#twitter">t</a>
              <a href="#linkedin">in</a>
              <a href="#instagram">o</a>
            </div>
          </div>
          <div className={styles.footerLinks}>
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#owners">For Home Owners</a></li>
              <li><a href="#professionals">For Professionals</a></li>
              <li><a href="#jobs">Jobs</a></li>
              <li><a href="#social">Social Media</a></li>
              <li><a href="#prices">Prices</a></li>
              <li><a href="#education">Education Resources</a></li>
              <li><a href="/contact-support">Contact</a></li> {/* Updated link */}
            </ul>
          </div>
          <div className={styles.footerLinks}>
            <h4>Directory</h4>
            <ul>
              <li><a href="#ac">Airconditioning</a></li>
              <li><a href="#builders">Builders</a></li>
              <li><a href="#concreters">Concreters</a></li>
              <li><a href="#design">Design</a></li>
              <li><a href="#estimators">Estimators</a></li>
              <li><a href="#gardeners">Gardeners</a></li>
              <li><a href="#more">More......</a></li>
            </ul>
          </div>
          <div className={styles.footerLinks}>
            <h4>Resources</h4>
            <ul>
              <li><a href="#terminology">Terminology</a></li>
              <li><a href="#charts">Flow Charts</a></li>
              <li><a href="#tips">Design Tips</a></li>
              <li><a href="#how-tos">How tos</a></li>
              <li><a href="#support">Support</a></li>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#library">Resource library</a></li>
            </ul>
          </div>
        </div>
      </div>
       <div className={styles.footerBottom}>
          <p>©Copyright 2025 https://buildstart.au | All Rights Reserved</p>
        </div>
    </footer>
  );
};

// FAQ Data
const faqData = [
    {
        question: "How do I post a job on Build Start?",
        answer: "To post a job, simply navigate to the 'Post a Job' section after logging in as a Home Owner. Provide details about your project, including the type of work, location, budget, and any specific requirements. Our platform will then match you with relevant building professionals."
    },
    {
        question: "How do businesses reply to job leads?",
        answer: "Businesses can view available job leads on their dashboard. To reply, they can submit a quote or message the home user directly through the platform. Ensure your business profile is complete to increase your chances of being selected."
    },
    {
        question: "Can I search for businesses without posting a job?",
        answer: "Yes, as a Home User, you can use our search functionality to find businesses by trade, location, or specific services. You can view their profiles, portfolios, and reviews before deciding to contact them or post a job."
    },
    {
        question: "What kind of businesses are listed on Build Start?",
        answer: "Build Start features a wide range of building professionals, including plumbers, electricians, builders, architects, landscapers, and many more. We focus on connecting users with trusted and vetted professionals in various trades."
    },
    {
        question: "Is there a fee to use Build Start?",
        answer: "Home Users can post jobs and search for businesses for free. For Building Professionals, we offer various subscription plans to access job leads and enhance their business visibility. Please refer to our 'Prices' or 'Subscription' page for more details."
    },
    {
        question: "How does Build Start ensure the quality of professionals?",
        answer: "We have a rigorous vetting process, including license and insurance verification, reputation and review analysis, and portfolio checks. We continuously monitor performance to ensure our professionals meet high standards."
    },
    {
        question: "What if I have an issue with a professional I hired through Build Start?",
        answer: "While we strive to connect you with the best, if an issue arises, we encourage direct communication between parties first. If unresolved, you can contact our support team at support@buildstart.au for assistance. We aim to facilitate fair resolutions."
    },
    {
        question: "Do you offer phone support?",
        answer: "Currently, we do not offer telephone support. For all inquiries, please reach out to us via email at support@buildstart.au or use the contact form on this page. We aim to respond to all queries promptly."
    }
];

const ContactSupportPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [openFaq, setOpenFaq] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const filteredFaqs = useMemo(() => {
        return faqData.filter(faq =>
            faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
            faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm]);

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            // Assuming your backend API endpoint for contact form is /api/contact
            const response = await api.post('/api/contact', formData);
            if (response.status === 200) {
                alert('Thank you for your message! We will get back to you shortly.');
                setFormData({ name: '', email: '', subject: '', message: '' }); // Clear form
            } else {
                alert('Failed to send message. Please try again later.');
            }
        } catch (error) {
            console.error('Error submitting contact form:', error);
            alert('An error occurred while sending your message. Please try again.');
        }
    };

    return (
        <>
            <Header />
            <main>
                <section className={`${supportStyles.hero} ${supportStyles.heroSupport}`}>
                    <div className={styles.container}>
                        <div className={supportStyles.heroContent}>
                            <h1>Contact Us & Support</h1>
                            <p>We're here to help you with any questions about posting jobs, finding professionals, or using our platform.</p>
                        </div>
                    </div>
                </section>

                <section className={`${styles.sectionPadding} ${supportStyles.contactSection}`}>
                    <div className={styles.container}>
                        <div className={supportStyles.contactGrid}>
                            <div className={supportStyles.contactInfo}>
                                <h2>Get in Touch</h2>
                                <p>Whether you have a question about features, trials, pricing, or anything else, our team is ready to answer all your questions.</p>
                                <div className={supportStyles.infoItem}>
                                    <FaEnvelope size={24} />
                                    <div>
                                        <h3>Email Support</h3>
                                        <p>Our primary support channel. We aim to respond within 24-48 hours.</p>
                                        <p><a href="mailto:support@buildstart.au">support@buildstart.au</a></p>
                                    </div>
                                </div>
                                <div className={supportStyles.infoItem}>
                                    <FaPhoneAlt size={24} />
                                    <div>
                                        <h3>Phone Support</h3>
                                        <p>We currently do not offer telephone support to ensure we can provide the most efficient and detailed responses via email.</p>
                                    </div>
                                </div>
                                <div className={supportStyles.infoItem}>
                                    <FaMapMarkerAlt size={24} />
                                    <div>
                                        <h3>Office Location</h3>
                                        <p>Online platform only. No physical office for walk-in support.</p>
                                    </div>
                                </div>
                            </div>

                            <div className={supportStyles.contactForm}>
                                <h2>Send Us a Message</h2>
                                <form onSubmit={handleFormSubmit}>
                                    <div className={supportStyles.formGroup}>
                                        <label htmlFor="name">Your Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                    <div className={supportStyles.formGroup}>
                                        <label htmlFor="email">Your Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                    <div className={supportStyles.formGroup}>
                                        <label htmlFor="subject">Subject</label>
                                        <input
                                            type="text"
                                            id="subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                    <div className={supportStyles.formGroup}>
                                        <label htmlFor="message">Your Message</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            rows="6"
                                            value={formData.message}
                                            onChange={handleFormChange}
                                            required
                                        ></textarea>
                                    </div>
                                    <button type="submit" className={styles.btnPrimary}>Send Message</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>

                <section className={`${styles.sectionPadding} ${supportStyles.faqSection}`}>
                    <div className={styles.container}>
                        <h2 className={styles.sectionTitle}>Frequently Asked Questions</h2>
                        <div className={supportStyles.searchBar}>
                            <FaSearch />
                            <input
                                type="text"
                                placeholder="Search FAQs..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className={supportStyles.faqList}>
                            {filteredFaqs.length > 0 ? (
                                filteredFaqs.map((faq, index) => (
                                    <div key={index} className={supportStyles.faqItem}>
                                        <button
                                            className={supportStyles.faqQuestion}
                                            onClick={() => setOpenFaq(openFaq === index ? null : index)}
                                        >
                                            {faq.question}
                                            <FaChevronDown className={`${supportStyles.faqIcon} ${openFaq === index ? supportStyles.open : ''}`} />
                                        </button>
                                        {openFaq === index && (
                                            <div className={supportStyles.faqAnswer}>
                                                <p>{faq.answer}</p>
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <p className={supportStyles.noResults}>No FAQs found matching your search.</p>
                            )}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default ContactSupportPage;
